import React, { useEffect, useState } from "react";
import AddSharpIcon from "@mui/icons-material/AddSharp";
import toast from "react-hot-toast";
import axios, { PublicKey } from "../../API/axios";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import DeleteSharpIcon from "@mui/icons-material/DeleteSharp";
import AddEducation from "./AddEducation";
import EditEducation from "./EditEducation";
import AddExperience from "./AddExperience";
import EditExperience from "./EditExperience";
import AddExperienceRole from "./AddExperienceRole";
import EditExperienceRole from "./EditExperienceRole";
import AddExperienceAchivement from "./AddExperienceAchivement";
import EditExperienceAchivement from "./EditExperienceAchievement";
import AddCertificate from "./AddCertificate";
import UpdateCertificate from "./UpdateCertificate";
import AddAward from "./AddAward";
import UpdateAward from "./UpdateAward";

import AddSkills from "./AddSkills";
import EditSharpIcon from "@mui/icons-material/EditSharp";
import LinkSharpIcon from '@mui/icons-material/LinkSharp';
import EditSkills from "./EditSkills";
import AddAttachement from "./AddAttachement";
import EditAttachement from "./EditAttachement";

import UpdateResume from "./UpdateResume";
import DeleteOutlineSharpIcon from "@mui/icons-material/DeleteOutlineSharp";
import moment from "moment";
import { Modal } from "react-bootstrap";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";

import AddProject from "./AddProject";
import EditProject from "./EditProject";
import PlaceSharpIcon from "@mui/icons-material/PlaceSharp";
import AddEducationActivity from "./AddEducationActivity";
import UpdateEducationActivity from "./UpdateEducationActivity";
import AddEducationAchievement from "./AddEducationAchievement";
import UpdateEducationAchievement from "./UpdateEducationAchievement";
import UpdateLangugae from "./UpdateLangugae";
import CareerGap from "./CareerGap";

const ResumeDetails = () => {
	const sessionId = localStorage.getItem("sessionId");
	const UserType = localStorage.getItem("userType");
	const { CandidateId } = useParams();
	const navigate = useNavigate();
	console.log("CandidateId==", CandidateId);

	//  *******************************     RESUME LISTING   ************************************************

	const [userDataId, setUserDataId] = useState([]);
	const [userEducation, setUserEducation] = useState([]);
	const [userEduActivity, setUserEduActivity] = useState([]);
	const [userEduAchievements, setUserEduAchievements] = useState([]);
	const [userAwards, setUserAwards] = useState([]);
	const [userExperience, setUserExperience] = useState([]);
	const [userCertification, setUserCertification] = useState([]);
	const [userDataInfo, setUserDataInfo] = useState([]);
	const [projectData, setProjectData] = useState([]);
	const [userSkill, setUserSkill] = useState([]);
	const location = useLocation();
	const queryParams = new URLSearchParams(location.search);
	const CnddtId = queryParams.get("CnddtId");
	const InsttId = queryParams.get("InsttId");
	const [loading, setLoading] = useState(true);

	console.log("userEducation", userEducation);


	const getUserCv = async () => {

		const data = {
			sessionId: sessionId,
			userType: UserType,
			instnCnddtID: CandidateId === 'Candidate' ? null : CandidateId
		};
		console.log("dataaaa", data);

		try {
			await axios.post(`/Resume/Get`, data).then((resData) => {
				console.log("resData", resData);

				console.log("UserAwards", resData.data.responseData.userDataInfo.userDataId);
				console.log("skills", resData.data.responseData.skills);

				// const educations = resData.data.responseData.educations || [];
				// const firstEducation = educations.length > 0 ? educations[0] : null;

				setUserDataId(resData.data.responseData.userDataInfo.userDataId);
				console.log("education", resData.data.responseData.educations);

				setUserEducation(resData.data.responseData.educations);
				// setUserEduActivity(firstEducation ? firstEducation.usrDataEducationActivities : []);
				// setUserEduAchievements(firstEducation ? firstEducation.usrDataEducationAchievements : []); // Setting the value
				setUserAwards(resData.data.responseData.awards);
				setUserExperience(resData.data.responseData.experiences);
				setUserSkill(resData.data.responseData.skills);
				setUserCertification(resData.data.responseData.certifications);
				setUserDataInfo(resData.data.responseData.userDataInfo);
				setProjectData(resData.data.responseData.projects);
			});
		} catch (error) {
			console.log(error);

			// toast.error(error.response.data.message);
		} finally {
			setLoading(false);
		}
	};
	console.log("userDataId======>", userDataId);
	console.log("userDataInfo======>", userDataInfo);
	console.log("userEducatiosss>", userEducation);

	console.log("userEduActivity", userEduActivity, userEduAchievements);

	useEffect(() => {
		getUserCv();
	}, []);

	//  *******************************    RESUME LISTING  ************************************************

	//  *******************************    ALL RESUME UPDATE ACTIONS ************************************************
	const [showEditViewResume, setShowEditViewResume] = useState(false);
	const hanndleOpenEditViewResume = () => setShowEditViewResume(true);
	const handleCloseEditViewResume = () => setShowEditViewResume(false);
	//  *******************************    ALL RESUME UPDATE ACTIONS ************************************************
	//  *******************************    ALL RESUME UPDATE ACTIONS ************************************************
	const [showEditActiveAs, setShowEditActiveAs] = useState(false);
	const hanndleOpenActiveAs = () => setShowEditActiveAs(true);
	const handleCloseActiveAs = () => setShowEditActiveAs(false);
	//  *******************************    ALL RESUME UPDATE ACTIONS ************************************************

	//  *******************************    ALL EDUCATION ACTIONS ************************************************
	// .................... Add Education
	const [showEducation, setShowEducation] = useState(false);
	const handleOpenEducation = () => setShowEducation(true);
	const handleCloseEducation = () => setShowEducation(false);

	// .................... Update Education
	const [showEducationUpdate, setShowEducationUpdate] = useState(false);
	const handleCloseUpdateEducation = () => setShowEducationUpdate(false);
	const [educationData, setEducationData] = useState([]);

	// .................... Delete Education
	const [educationId, setEducationId] = useState("");
	const [showEducationDelete, setShowEducationDelete] = useState(false);
	const handleRemoveEducationClose = () => {
		setShowEducationDelete(false);
	};
	const DeleteEducation = async () => {
		const Data = {
			sessionId: sessionId,
			userDataId: userDataId,
			userType: UserType,
			instnCnddtID: CandidateId === "Candidate" ? null : CandidateId,
			eduId: educationId,
		};
		try {
			const response = await axios.post("/Resume/DeleteEducation", Data, {
				headers: {
					PublicKey,
				},
			});
			toast.success(response.data.message);
			handleRemoveEducationClose();
			getUserCv();
		} catch (error) {
			console.error("Error deleting account:", error);
			toast.error(error.response.data.message);
		}
	};

	// .................... Enable Education
	const EnableEducation = async (id) => {
		const Data = {
			sessionId: sessionId,
			userDataId: userDataId,
			userType: UserType,
			instnCnddtID: CandidateId === "Candidate" ? null : CandidateId,
			eduId: id,
		};
		try {
			const response = await axios.post("/Resume/EnableEducation", Data, {
				headers: {
					PublicKey,
				},
			});
			console.log("education toggle", response);

			toast.success(response.data.message);
			getUserCv();
		} catch (error) {
			console.error("Error deleting account:", error);
			toast.error(error.response.data.message);
		}
	};
	// .................... Disable Education
	const DisableEducation = async (id) => {
		const Data = {
			sessionId: sessionId,
			userDataId: userDataId,
			userType: UserType,
			instnCnddtID: CandidateId === "Candidate" ? null : CandidateId,
			eduId: id,
		};
		try {
			const response = await axios.post("/Resume/DisableEducation", Data, {
				headers: {
					PublicKey,
				},
			});
			toast.success(response.data.message);
			getUserCv();
		} catch (error) {
			console.error("Error deleting account:", error);
			toast.error(error.response.data.message);
		}
	};
	//  *******************************   ALL EDUCATION ACTIONS  ************************************************

	//  *******************************   ALL EXPERIENCE ACTIONS  ************************************************
	// .................... Add Experience
	const [showExperience, setShowExperience] = useState(false);
	const handleOpenExperience = () => setShowExperience(true);
	const handleCloseExperience = () => setShowExperience(false);

	// ....................Update Experience
	const [experienceData, setExperienceData] = useState("");
	const [showEditExperience, setShowEditExperience] = useState(false);
	const handleOpenEditExperience = () => setShowEditExperience(true);
	const handleCloseEditExperience = () => setShowEditExperience(false);

	// ....................Delete Experience
	const [ExperienceId, setExperienceId] = useState("");
	const [showExperienceDelete, setShowExperienceDelete] = useState(false);
	const handleRemoveExperienceClose = () => {
		setShowExperienceDelete(false);
	};
	const DeleteExperience = async () => {
		const Data = {
			sessionId: sessionId,
			userDataId: userDataId,
			userType: UserType,
			instnCnddtID: CandidateId === "Candidate" ? null : CandidateId,
			expId: ExperienceId,
		};
		try {
			const response = await axios.post("/Resume/DeleteExperience", Data, {
				headers: {
					PublicKey,
				},
			});
			toast.success(response.data.message);
			handleRemoveExperienceClose();
			getUserCv();
		} catch (error) {
			console.error("Error deleting account:", error);
			toast.error(error.response.data.message);
		}
	};

	//....................Enable Experience
	const EnableExperience = async (id) => {
		const Data = {
			sessionId: sessionId,
			userDataId: userDataId,
			userType: UserType,
			instnCnddtID: CandidateId === "Candidate" ? null : CandidateId,
			expId: id,
		};
		try {
			const response = await axios.post("/Resume/EnableExperience", Data, {
				headers: {
					PublicKey,
				},
			});
			console.log("toggle response", response);

			toast.success(response.data.message);
			getUserCv();
		} catch (error) {
			console.error("Error deleting account:", error);
			toast.error(error.response.data.message);
		}
	};

	//....................Enable Experience
	const DisableExperience = async (id) => {
		const Data = {
			sessionId: sessionId,
			userDataId: userDataId,
			userType: UserType,
			instnCnddtID: CandidateId === "Candidate" ? null : CandidateId,
			expId: id,
		};
		try {
			const response = await axios.post("/Resume/DisableExperience", Data, {
				headers: {
					PublicKey,
				},
			});
			toast.success(response.data.message);
			getUserCv();
		} catch (error) {
			console.error("Error deleting account:", error);
			toast.error(error.response.data.message);
		}
	};

	//....................Add Experience Role
	const [showExperienceRole, setShowExperienceRole] = useState(false);
	const handleOpenExperienceRole = () => setShowExperienceRole(true);
	const handleCloseExperienceRole = () => setShowExperienceRole(false);

	//....................Update Experience Role
	const [experienceRoleData, setExperienceRoleData] = useState("");
	const [showEditExperienceRole, setShowEditExperienceRole] = useState(false);
	const handleOpenEditExperienceRole = () => setShowEditExperienceRole(true);
	const handleCloseEditExperienceRole = () => setShowEditExperienceRole(false);

	//....................Delete Experience Role
	const [ExperienceRole, setExperienceRole] = useState("");
	const [ExperienceRoleId, setExperienceRoleId] = useState("");

	const [showExperienceRoleDelete, setShowExperienceRoleDelete] =
		useState(false);
	const handleRemoveExperienceRoleClose = () => {
		setShowExperienceRoleDelete(false);
	};
	const DeleteExperienceRole = async () => {
		const Data = {
			sessionId: sessionId,
			userDataId: userDataId,
			userType: UserType,
			instnCnddtID: CandidateId === "Candidate" ? null : CandidateId,
			expId: ExperienceId,
			id: ExperienceRoleId,
		};
		try {
			const response = await axios.post("/Resume/DeleteExperienceRole", Data, {
				headers: {
					PublicKey,
				},
			});
			toast.success(response.data.message);
			getUserCv();
			handleRemoveExperienceRoleClose();
		} catch (error) {
			console.error("Error deleting account:", error);
			toast.error(error.response.data.message);
		}
	};

	//....................Enable Experience Role
	const EnableExperienceRole = async (id, role, ExpID) => {
		const Data = {
			sessionId: sessionId,
			userDataId: userDataId,
			userType: UserType,
			instnCnddtID: CandidateId === "Candidate" ? null : CandidateId,
			expId: ExpID,
			id: id,
		};
		try {
			const response = await axios.post("/Resume/EnableExperienceRole", Data, {
				headers: {
					PublicKey,
				},
			});
			toast.success(response.data.message);
			getUserCv();
		} catch (error) {
			console.error("Error deleting account:", error);
			toast.error(error.response.data.message);
		}
	};

	//....................Disable Experience Role
	const DisableExperienceRole = async (id, role, ExpID) => {
		const Data = {
			sessionId: sessionId,
			userDataId: userDataId,
			userType: UserType,
			instnCnddtID: CandidateId === "Candidate" ? null : CandidateId,
			expId: ExpID,
			id: id,
		};
		try {
			const response = await axios.post("/Resume/DisableExperienceRole", Data, {
				headers: {
					PublicKey,
				},
			});
			toast.success(response.data.message);
			getUserCv();
		} catch (error) {
			console.error("Error deleting account:", error);
			toast.error(error.response.data.message);
		}
	};

	//....................Add Experience Achiewement
	const [showExperienceAchivement, setShowExperienceAchivement] =
		useState(false);
	const handleOpenExperienceAchivement = () =>
		setShowExperienceAchivement(true);
	const handleCloseExperienceAchivement = () =>
		setShowExperienceAchivement(false);

	//....................Update Experience Achiewement
	const [experienceAchivementData, setExperienceAchivementData] = useState("");
	const [showEditExperienceAchivement, setShowEditExperienceAchivement] =
		useState(false);
	const handleOpenEditExperienceAchivement = () =>
		setShowEditExperienceAchivement(true);
	const handleCloseEditExperienceAchivement = () =>
		setShowEditExperienceAchivement(false);

	//....................Add Education Activity
	const [showEducationActivity, setShowEducationActivity] = useState(false);
	const handleOpenEducationActivity = () => setShowEducationActivity(true);
	const handleCloseEducationActivity = () => setShowEducationActivity(false);

	//....................Update Education Activity
	const [educationActivityData, setEducationActivityData] = useState("");
	const [showUpdateEducationActivity, setShowEditEducationActivity] =
		useState(false);
	const handleOpenUpdateEducationActivity = () =>
		setShowEditEducationActivity(true);
	const handleCloseUpdateEducationActivity = () =>
		setShowEditEducationActivity(false);

	// .................... Delete Education Activity
	const [educationActivityId, setEducationActivityId] = useState("");
	const [showeducatonActivityDelete, setShowEducationActivityDelete] =
		useState(false);
	const handleEducationActivityClose = () => {
		setShowEducationActivityDelete(false);
	};

	const DeleteEducationActivity = async () => {
		const Data = {
			sessionId: sessionId,
			userDataId: userDataId,
			userType: UserType,
			instnCnddtID: CandidateId === "Candidate" ? null : CandidateId,
			eduId: educationId,
			eduActvtyId: educationActivityId,
		};
		console.log("data delete", Data);

		try {
			const response = await axios.post(
				"/Resume/DeleteEducationActivity",
				Data,
				{
					headers: {
						PublicKey,
					},
				}
			);
			toast.success(response.data.message);
			handleEducationActivityClose();
			getUserCv();
		} catch (error) {
			console.error("Error deleting account:", error);
			toast.error(error.response.data.message);
		}
	};

	//....................Add Education Ahievement
	const [showEducationAchievement, setShowEducationAhievement] =
		useState(false);
	const handleOpenEducationAhievement = () => setShowEducationAhievement(true);
	const handleCloseEducationAhievement = () =>
		setShowEducationAhievement(false);

	// .................... Delete Education Activity Achiev

	const [educationActivityAchievId, setEducationActivityAchievId] = useState("");
	const [educationActivityAchiev, setEducationActivityAchiev] = useState("");
	const [showeducatonActivityAchivDelete, setShowEducationActivityAchievDelete] =
		useState(false);
	const handleEducationActivityAchiveClose = () => {
		setShowEducationActivityAchievDelete(false);
	};

	const DeleteEducationActivityAchievement = async () => {
		const Data = {
			sessionId: sessionId,
			userDataId: userDataId,
			userType: UserType,
			instnCnddtID: CandidateId === "Candidate" ? null : CandidateId,
			eduId: educationId,
			id: 0,
			eduAchvmntId: educationActivityAchievId,
			achievement: educationActivityAchiev,
			achievementDate: moment(educationData).format("YYYY-MM-DD"),
		};
		console.log("data delete", Data);

		try {
			const response = await axios.post(
				"/Resume/DeleteEducationAchievement",
				Data,
				{
					headers: {
						PublicKey,
					},
				}
			);
			toast.success(response.data.message);
			handleEducationActivityAchiveClose();
			getUserCv();
		} catch (error) {
			console.error("Error deleting account:", error);
			toast.error(error.response.data.message);
		}
	};

	//....................Update Education Ahievement
	const [educationAchievementData, setEducationAchievementData] = useState("")
	const [showUpdateEducationAchievement, setShowUpdateEducationAchievement] =
		useState(false);
	const handleOpenUpdateEducationAchievement = () => setShowUpdateEducationAchievement(true);
	const handleCloseUpdateEducationAhievement = () =>
		setShowUpdateEducationAchievement(false);

	//....................Delete Experience Achiewement
	const [ExperienceAchivement, setExperienceAchivement] = useState("");
	const [ExperienceAchivementId, setExperienceAchivementId] = useState("");
	const [showExperienceAchievementDelete, setShowExperienceAchievementDelete] =
		useState(false);
	const handleExperienceAchievementClose = () => {
		setShowExperienceAchievementDelete(false);
	};
	const handleRemoveExperienceAchivementClose = () => {
		setShowExperienceAchievementDelete(false);
	};
	const DeleteExperienceAchivement = async () => {
		const Data = {
			sessionId: sessionId,
			userDataId: userDataId,
			userType: UserType,
			instnCnddtID: CandidateId === "Candidate" ? null : CandidateId,
			expId: ExperienceId,
			id: ExperienceAchivementId,
		};
		try {
			const response = await axios.post(
				"/Resume/DeleteExperienceAchievement",
				Data,
				{
					headers: {
						PublicKey,
					},
				}
			);
			toast.success(response.data.message);
			getUserCv();
			handleRemoveExperienceAchivementClose();
		} catch (error) {
			console.error("Error deleting account:", error);
			toast.error(error.response.data.message);
		}
	};

	//....................Enable Experience Achiewement
	const EnableExperienceAchivement = async (id, role, ExpID) => {
		const Data = {
			sessionId: sessionId,
			userDataId: userDataId,
			userType: UserType,
			instnCnddtID: CandidateId === "Candidate" ? null : CandidateId,
			expId: ExpID,
			id: id,
		};
		try {
			const response = await axios.post(
				"/Resume/EnableExperienceAchievement",
				Data,
				{
					headers: {
						PublicKey,
					},
				}
			);
			toast.success(response.data.message);
			getUserCv();
		} catch (error) {
			console.error("Error deleting account:", error);
			toast.error(error.response.data.message);
		}
	};

	//....................Disable Experience Achiewement
	const DisableExperienceAchivement = async (id, role, ExpID) => {
		const Data = {
			sessionId: sessionId,
			userDataId: userDataId,
			userType: UserType,
			instnCnddtID: CandidateId === "Candidate" ? null : CandidateId,
			expId: ExpID,
			id: id,
		};

		try {
			const response = await axios.post(
				"/Resume/DisableExperienceAchievement",
				Data,
				{
					headers: {
						PublicKey,
					},
				}
			);
			toast.success(response.data.message);
			getUserCv();
		} catch (error) {
			console.error("Error deleting account:", error);
			toast.error(error.response.data.message);
		}
	};

	//  *******************************   ALL EXPERIENCE ACTIONS  ************************************************

	//  *******************************   ALL CERTIFICATE ACTIONS  ************************************************
	//....................Add Certificate
	const [showCVCertification, setShowCVCertification] = useState(false);
	const handleOpenCVCertification = () => setShowCVCertification(true);
	const handleCloseCVCertification = () => setShowCVCertification(false);

	//...................Update Certificate
	const [certificateData, setCertificateData] = useState("");
	const [showEditCertificate, setShowEditCertificate] = useState(false);
	const handleOpenEditCertificate = () => setShowEditCertificate(true);
	const handleCloseEditCertificate = () => setShowEditCertificate(false);

	//...................Delete Certificate
	const [certId, setCertId] = useState("");
	const [showCertificationDelete, setShowCertificationDelete] = useState(false);
	const handleRemoveCertificationClose = () => {
		setShowCertificationDelete(false);
	};
	const DeleteCertification = async () => {
		const Data = {
			sessionId: sessionId,
			userDataId: userDataId,
			userType: UserType,
			instnCnddtID: CandidateId === "Candidate" ? null : CandidateId,
			certId: certId,
		};

		try {
			const response = await axios.post("/Resume/DeleteCertification", Data, {
				headers: {
					PublicKey,
				},
			});
			toast.success(response.data.message);
			handleRemoveCertificationClose();
			getUserCv();
		} catch (error) {
			console.error("Error deleting account:", error);
			toast.error(error.response.data.message);
		}
	};

	//...................Enable Certificate
	const EnableCertificate = async (id) => {
		const Data = {
			sessionId: sessionId,
			userDataId: userDataId,
			userType: UserType,
			instnCnddtID: CandidateId === "Candidate" ? null : CandidateId,
			certId: id,
		};
		try {
			const response = await axios.post("/Resume/EnableCertification", Data, {
				headers: {
					PublicKey,
				},
			});
			toast.success(response.data.message);
			getUserCv();
		} catch (error) {
			console.error("Error deleting account:", error);
			toast.error(error.response.data.message);
		}
	};

	//...................Disable Certificate
	const DisableCertificate = async (id) => {
		const Data = {
			sessionId: sessionId,
			userDataId: userDataId,
			userType: UserType,
			instnCnddtID: CandidateId === "Candidate" ? null : CandidateId,
			certId: id,
		};
		try {
			const response = await axios.post("/Resume/DisableCertification", Data, {
				headers: {
					PublicKey,
				},
			});
			toast.success(response.data.message);
			getUserCv();
		} catch (error) {
			console.error("Error deleting account:", error);
			toast.error(error.response.data.message);
		}
	};

	//  *******************************   ALL CERTIFICATE ACTIONS  ************************************************

	//  *******************************   ALL AWARD ACTIONS  ************************************************
	//...................Add Award
	const [showAward, setShowAward] = useState(false);
	const handleOpenAward = () => setShowAward(true);
	const handleCloseAward = () => setShowAward(false);

	//...................Update Award
	const [awardData, setAwardData] = useState("");
	const [awardId, setAwardId] = useState("");
	const [showCVUpdateAward, setShowUpdateCVAward] = useState(false);
	const handleOpenUpdateCVAward = () => setShowUpdateCVAward(true);
	const handleCloseUpdateCVAward = () => setShowUpdateCVAward(false);

	//...................Delete Award
	const [showAwardDelete, setShowAwardDelete] = useState(false);
	const handleRemoveAwardClose = () => {
		setShowAwardDelete(false);
	};
	const DeleteAward = async () => {
		const Data = {
			sessionId: sessionId,
			userDataId: userDataId,
			userType: UserType,
			instnCnddtID: CandidateId === "Candidate" ? null : CandidateId,
			awrdId: awardId,
		};
		try {
			const response = await axios.post("/Resume/DeleteAward", Data, {
				headers: {
					PublicKey,
				},
			});
			toast.success(response.data.message);
			handleRemoveAwardClose();
			getUserCv();
		} catch (error) {
			console.error("Error deleting account:", error);
			toast.error(error.response.data.message);
		}
	};

	//...................Enable Award
	const EnableAward = async (id) => {
		const Data = {
			sessionId: sessionId,
			userDataId: userDataId,
			userType: UserType,
			instnCnddtID: CandidateId === "Candidate" ? null : CandidateId,
			awrdId: id,
		};
		try {
			const response = await axios.post("/Resume/EnableAward", Data, {
				headers: {
					PublicKey,
				},
			});
			toast.success(response.data.message);
			getUserCv();
		} catch (error) {
			console.error("Error deleting account:", error);
			toast.error(error.response.data.message);
		}
	};

	//...................Disable Award
	const DisableAward = async (id) => {
		const Data = {
			sessionId: sessionId,
			userDataId: userDataId,
			userType: UserType,
			instnCnddtID: CandidateId === "Candidate" ? null : CandidateId,
			awrdId: id,
		};
		try {
			const response = await axios.post("/Resume/DisableAward", Data, {
				headers: {
					PublicKey,
				},
			});
			toast.success(response.data.message);
			getUserCv();
		} catch (error) {
			console.error("Error deleting account:", error);
			toast.error(error.response.data.message);
		}
	};
	//  *******************************   ALL AWARD ACTIONS  ************************************************

	//  *******************************   ALL SKILLS ACTIONS  ************************************************

	const [showAddSkill, setShowAddSkill] = useState(false);
	const handleOpenAddSkill = () => setShowAddSkill(true);
	const handleCloseAddSkill = () => setShowAddSkill(false);

	//...................Update Skill
	const [skillsData, setSkillsData] = useState([]);
	const [showSkillsUpdate, setShowSkillsUpdate] = useState(false);
	const handleCloseSkillUpdate = () => setShowSkillsUpdate(false);

	//...................Delete Skill
	const [skillId, setSkillId] = useState("");
	const [showskillDelete, setShowSkillDelete] = useState(false);
	const handleRemoveskillClose = () => {
		setShowSkillDelete(false);
	};
	const DeleteSkill = async () => {
		const Data = {
			sessionId: sessionId,
			userDataId: userDataId,
			userType: UserType,
			instnCnddtID: CandidateId === "Candidate" ? null : CandidateId,
			usrSkllId: skillId,
		};
		try {
			const response = await axios.post("/Resume/DeleteSkill", Data, {
				headers: {
					PublicKey,
				},
			});
			toast.success(response.data.message);
			handleRemoveskillClose();
			getUserCv();
		} catch (error) {
			console.error("Error deleting account:", error);
			toast.error(error.response.data.message);
		}
	};

	//...................Enable Skill
	//...................Disable Skill
	//  *******************************   ALL SKILLS ACTIONS  ************************************************

	//  *******************************   ALL PROJECTS ACTIONS  ************************************************
	//...................Add Project
	const [showAddProject, setShowAddProject] = useState(false);
	const handleOpenAddProject = () => setShowAddProject(true);
	const handleCloseAddProject = () => setShowAddProject(false);

	//...................Update Project
	const [projectAllData, setProjectAllData] = useState("");
	const [showEditProject, setShowEditProject] = useState(false);
	const handleOpenEditProject = () => setShowEditProject(true);
	const handleCloseEditProject = () => setShowEditProject(false);

	//...................Delete Project
	const [projectId, setProjectId] = useState("");
	const [showProjectDelete, setShowProjectDelete] = useState(false);
	const handleProjectClose = () => {
		setShowProjectDelete(false);
	};
	const DeleteProject = async () => {
		const Data = {
			sessionId: sessionId,
			userDataId: userDataId,
			userType: UserType,
			instnCnddtID: CandidateId === "Candidate" ? null : CandidateId,
			prjctId: projectId,
		};
		try {
			const response = await axios.post("/Resume/DeleteProject", Data, {
				headers: {
					PublicKey,
				},
			});
			toast.success(response.data.message);
			handleProjectClose();
			getUserCv();
		} catch (error) {
			console.error("Error deleting account:", error);
			toast.error(error.response.data.message);
		}
	};

	//...................Enable Project
	const EnableProject = async (id) => {
		const Data = {
			sessionId: sessionId,
			userDataId: userDataId,
			userType: UserType,
			instnCnddtID: CandidateId === "Candidate" ? null : CandidateId,
			prjctId: id,
		};
		try {
			const response = await axios.post("/Resume/EnableProject", Data, {
				headers: {
					PublicKey,
				},
			});
			toast.success(response.data.message);
			getUserCv();
		} catch (error) {
			console.error("Error deleting account:", error);
			toast.error(error.response.data.message);
		}
	};

	//...................Disable Project
	const DisableProject = async (id) => {
		const Data = {
			sessionId: sessionId,
			userDataId: userDataId,
			userType: UserType,
			instnCnddtID: CandidateId === "Candidate" ? null : CandidateId,
			prjctId: id,
		};
		try {
			const response = await axios.post("/Resume/DisableProject", Data, {
				headers: {
					PublicKey,
				},
			});
			toast.success(response.data.message);
			getUserCv();
		} catch (error) {
			console.error("Error deleting account:", error);
			toast.error(error.response.data.message);
		}
	};
	//  *******************************   ALL PROJECTS ACTIONS  ************************************************

	//  *******************************   ALL SKILLS ACTIONS  ************************************************

	const [showCareer, setShowCareer] = useState(false);
	const handleOpenCareer = () => setShowCareer(true);
	const handleCloseCareer = () => setShowCareer(false);



	//  *******************************   Languages ACTIONS  ************************************************
	const [languageModal, setLanguageModal] = useState(false)
	//  *******************************   Languages ACTIONS  ************************************************


	return (
		<>
			{loading ? (
				<div className="mt-6 d-flex justify-content-center">
					<p>Loading...</p>
				</div>
			) : (
				<>
					<div className="main-container resume ">
						<div className="content-wrapper resume-details-content-wrapper">
							{/* //  *******************************    BASIC INFO START ************************************************ */}

							<div className="d-flex justify-content-between align-items-end View-Resume-card">
								<div className="title delete-title ">
									<h1 className="f-600">
										<span className="orange-box"></span> Manage Resume
									</h1>
								</div>
								<div className="add-class-submit-button  d-flex justify-content-center">
									{/* <div className="resumeAction">
								<EditSharpIcon
									onClick={hanndleOpenEditViewResume}
									className="pointer locationIcon f-24 me-1"
								/>
							</div> */}
								</div>
							</div>

							<div className="card basic-info d-flex align-center">
								<div className="post-job-details-form Edit-Card-details-form">
									<div className="ms-2"></div>
									<div className="post-form-">
											<div className="d-flex justify-content-between border-custom">
												<div className="title">
													<h6 className="f-600">Basic Info</h6>
												</div>
											</div>
										<div className="basic-info">
											{userDataInfo?.fullName && (
												<div
													className={`analytic-sub mt-2 mb-1 border-bottom  pb-2 d-flex justify-content-between`}
												>
													<div className="d-flex align-items-start justify-content-between">
														<div className="ms-2">
															<div className="d-flex align-items-center verified">
																<p className="f-14 fw-bold mb-1">Full Name</p>
															</div>
															<div className="content-data">
																<p className="ms-1 f-12 mb-1">
																	{userDataInfo?.fullName}
																</p>
															</div>
														</div>
													</div>
													<div className="resumeAction">
														<EditSharpIcon
															onClick={hanndleOpenEditViewResume}
															className="pointer locationIcon f-24 me-1"
														/>
													</div>
												</div>
											)}
											{userDataInfo?.dob && (
												<div
													className={`analytic-sub mt-2 mb-1 border-bottom  pb-2`}
												>
													<div className="d-flex align-items-start justify-content-between">
														<div className="ms-2">
															<div className="d-flex align-items-center verified">
																<p className="f-14 fw-bold mb-1">Date Of Birth</p>
															</div>
															<div className="content-data">
																<p className="ms-1 f-12 mb-1">
																	{/* {userDataInfo?.dob} */}
																	{moment(userDataInfo?.dob).format("DD MMM YYYY")}
																</p>
															</div>
														</div>
													</div>
												</div>
											)}
											{userDataInfo?.phoneNumber !== null && userDataInfo?.phoneNumber !== "" ? (
												<div className="analytic-sub mt-2 mb-1 border-bottom pb-2">
													<div className="d-flex align-items-start justify-content-between">
														<div className="ms-2">
															<div className="d-flex align-items-center verified">
																<p className="f-14 fw-bold mb-1">Contact No</p>
															</div>
															<div className="content-data">
																<p className="ms-1 f-12 mb-1">{userDataInfo?.phoneNumber}</p>
															</div>
														</div>
													</div>
												</div>
											) : (
												<div className="analytic-sub mt-2 mb-1 border-bottom pb-2">
													<div className="d-flex align-items-start justify-content-between">
														<div className="ms-2">
															<div className="d-flex align-items-center verified">
																<p className="f-14 fw-bold mb-1">Contact No</p>
															</div>
															<div className="text-red">
																<p className="ms-1 f-12 mb-1 ">Not Provided</p>
															</div>
														</div>
													</div>
												</div>
											)}

											{userDataInfo?.currentCity && (
												<div
													className={`analytic - sub mt - 2 mb - 1 border-bottom pb - 2`}
												>
													<div className="d-flex align-items-start justify-content-between">
														<div className="ms-2">
															<div className="d-flex align-items-center verified">
																<p className="f-14 fw-bold mb-1">City</p>
															</div>
															<div className="content-data">
																<p className="ms-1 f-12 mb-1">
																	{userDataInfo?.currentCity}
																</p>
															</div>
														</div>
													</div>
												</div>
											)}
											{userDataInfo?.email && (
												<div
													className={`analytic-sub mt-2 mb-1 border-bottom  pb-2`}
												>
													<div className="d-flex align-items-start justify-content-between">
														<div className="ms-2">
															<div className="d-flex align-items-center verified">
																<p className="f-14 fw-bold mb-1">Email</p>
															</div>
															<div className="content-data">
																<p className="ms-1 f-16 mb-1">
																	{userDataInfo?.email}
																</p>
															</div>
														</div>
													</div>
												</div>
											)}

										</div>
									</div>
								</div>
							</div>
							{/* //  *******************************    BASIC INFO END ************************************************ */}

							{/* //  *******************************    CAREER GAP CARD START ************************************************ */}
							{/* <div className="card d-flex align-center  Career-gap mt-2 pt-0 pb-0">
						<div className="post-job-details-form Edit-Card-details-form">
						<div className="profile-section">
							<div className="info-row mt-2">
							<div className="d-flex justify-content-between border-custom">
								<div className="title">
								<h6>Career Gap</h6>
								</div>
								<div
								className="addicon pointer"
								onClick={handleOpenCareer}
								>
								<AddSharpIcon
									onClick={() => {
									handleOpenCareer(); 
									}}
								/>
								</div>
							</div>
							</div>
						</div>
						</div>
					</div>   */}

							{/* //  *******************************    Active As CARD End ************************************************ */}
							<div className="card d-flex align-center Education mt-2 pt-0 pb-0  ">
								<div className="post-job-details-form Edit-Card-details-form">
									<div className="profile-section">

										{/* {userDataInfo?.languages && ( */}
										<div
											className={`analytic-sub mt-2  `}
										>
											<div className="d-flex justify-content-between border-custom">
												<div className="title">
													<h6 className="f-600">Profile Info</h6>
												</div>
											</div>
											<div className="d-flex justify-content-between  mt-2">


												<p className="f-14 mb-0 ">
													<span className='ms-2 f-14 f-400 fw-bold'>Active As: </span>{userDataInfo?.currentlyActiveAsName} {userDataInfo.headLine === "" || userDataInfo.headLine === null ? "" :
														<>
															({userDataInfo.headLine})
														</>
													}

												</p>
												<EditSharpIcon
													onClick={hanndleOpenActiveAs}
													className="pointer locationIcon f-24 me-1"
												/>
											</div>
											<div>
												<p className="f-14 mb-0">
													{userDataInfo?.currentlyActiveAsName === "Student" ? <span className='ms-2 f-14 f-400 fw-bold'>Institute: </span> :<span className='ms-2 f-14 f-400 fw-bold'>Orgnization: </span>}
													{userDataInfo?.orgName} {userDataInfo?.currentlyActiveAs === 2 ? <>
													<br />	<span className="ms-2 f-14 f-400 fw-bold">Designation: </span> {(userDataInfo.dsgntnName)}
													</> : null

													}
												</p>
												{userDataInfo.webSiteLink === null || userDataInfo.webSiteLink === "" ? (
													<> </>
												) : (
													<>
												<p className="ms-2 f-14 mb-0">
														<LinkSharpIcon className="material-symbols-sharp locationIcon f-16"/> {userDataInfo.webSiteLink}
												</p>
												</>
												)}
												{userDataInfo.address === null || userDataInfo.address === "" ? (
													<> </>
												) : (
													<>
														<p className="ms-2 f-12 mb-0">
															<PlaceSharpIcon className="material-symbols-sharp locationIcon f-14" />{userDataInfo.address}
														</p>
													</>
												)}
												<p className="ms-2 f-14 mb-0">
													{userDataInfo.about}
												</p>
											</div>
										</div>
									</div>
								</div>

							</div>

							{/* //  *******************************    Active As CARD End ************************************************ */}

							{/* //  *******************************    CAREER GAP CARD END ************************************************ */}
							{/* //  *******************************    Language CARD Start ************************************************ */}
							<div className="card d-flex align-center Education mt-2 pt-0 pb-0  ">
								<div className="post-job-details-form Edit-Card-details-form">
									<div className="profile-section">

										{userDataInfo?.languages && (
											<div
												className={`analytic-sub mt-2 `}
											>
												<div className="d-flex justify-content-between border-custom">
													<div className="title">
														<h6 className="f-600">RESUME LANGUAGE</h6>
													</div>
												</div>
												<div className="d-flex justify-content-between ">

													<p className="ms-2 f-14 mt-2 mb-0">
														{userDataInfo?.languages?.join(" , ")}
													</p>
													<div
														className="material-symbols-sharp pointer me-2 ms-2 locationIcon"
														onClick={() => {
															setLanguageModal(true)
														}}>
														<EditSharpIcon
														/>
													</div>
												</div>
											</div>
										)}
									</div>
								</div>

							</div>
							{/* //  *******************************    Language CARD End ************************************************ */}
							{/* //  *******************************    EDUCATION CARD START ************************************************ */}
							<div className="card d-flex align-center Education mt-2 pt-0 pb-0  ">
								<div className="post-job-details-form Edit-Card-details-form">
									<div className="profile-section">
										<div className=" mt-2">
											<div className="d-flex justify-content-between border-custom">
												<div className="title">
													<h6 className="f-600">Education</h6>
												</div>

												<div
													className="addicon pointer"
													onClick={() => {
														handleOpenEducation();
													}}
												>
													<AddSharpIcon />
												</div>
											</div>
											{userEducation &&
												userEducation
													.filter((item) => !item.isDeleted)
													?.map((item, index, filteredArray) => {
														console.log('item111', item);

														const isLastItem = index === filteredArray?.length - 1;
														return (
															<div
																className={`analytic-sub mt-2 mb-3 ${isLastItem ? "" : "border-custom"
																	} pb - 3`}
																key={index}
															>
																<div className="d-flex align-items-start justify-content-between">

																	<div className={`ms-2 ${item?.status !== 1 ? "disabled-row" : ""}`}>
																		<div className="d-flex verified">
																			<p className="f-14  fw-bold  m-0">
																				{item.institutionName} {item.grade === "" ? "" :
																					<>
																						({item.grade})
																					</>
																				}
																			</p>
																		</div>
																		<div className="d-flex">
																			<p className="  me-1 f-14 fw-bold mb-0">
																				{item.qualification}
																			</p>
																			{/* <div className="dot"></div> */}
																		</div>
																		<p className=" f-14   mb-0">
																			{item.specilization}
																		</p>
																		<p className="  f-14   mb-0">
																			{item.description}
																		</p>
																		<div className="d-flex align-items-center">
																			{item.cityName === null ? '' : <><PlaceSharpIcon className="material-symbols-sharp locationIcon f-14" />
																				<p className="mb-0  me-1 f-12">
																					{item.cityName}
																				</p></>}

																			<div className="dot"></div>
																			<p className="  f-12 mb-0 ">
																				{/* ({moment(item.startMonth).format("MMM")} {moment(item.startYear).format("YYYY")})
																		 {item.endMonth === null || item.endYear === "Invalid date" ? "- Is Present  " :
																			<>
																				({moment(item.endMonth).format("MMM")} {moment(item.endYear).format("YYYY")})
																				
																			</>
																		} */}
																				{/* ({moment(item.startMonth).format("MMM")} {moment(item.startYear).format("YYYY")}) {item.isPresent === true
																					? " - Present"
																					:
																					 <>
																						- ({moment(item.endMonth).format("MMM")} {moment(item.endYear).format("YYYY")})

																					</>
																				} */}
																				(
																				<>
																					{moment(item.startMonth).format("MMM")} {moment(item.startYear).format("YYYY")}
																					{item.isPresent === true ? (
																						" - Present"
																					) : (
																						item.endMonth && item.endYear ? (
																							<> - ({moment(item.endMonth).format("MMM")} {moment(item.endYear).format("YYYY")})</>
																						) : (
																							"" // or fallback like " - Not specified"
																						)
																					)}
																				</>
																				)


																			</p>
																		</div>
																	</div>
																	<div className="d-flex align-items-center updateActions">
																		<label class="switch">
																			<input
																				type="checkbox"
																				defaultChecked={item?.status === 1}
																				onClick={() => {
																					if (item?.status === 1) {
																						DisableEducation(item.usrDataEductnId);
																					} else {
																						EnableEducation(item.usrDataEductnId);
																					}
																				}}
																			/>
																			<span class="slider round"></span>
																		</label>

																		<EditSharpIcon
																			className={`material-symbols-sharp pointer me-2 ms-2 locationIcon ${item?.status !== 1 ? "disabled-row" : ""}`}
																			onClick={() => {
																				// hanndleOpenEditSkill();
																				setShowEducationUpdate(
																					!showEducationUpdate
																				);
																				setEducationData(item);
																			}}
																		/>
																		<DeleteOutlineSharpIcon
																			className="material-symbols-sharp pointer delete-icon text-red  "
																			onClick={() => {
																				setShowEducationDelete(
																					!showEducationDelete
																				);
																				setEducationId(item.usrDataEductnId);
																			}}
																		/>
																	</div>
																</div>
																<div className="mt-2">
																	<div className="d-flex justify-content-between align-center border-custom">
																		<div className="title  ">
																			<h6 className="f-12 f-600 ms-2 mb-1">Education Activity</h6>
																		</div>
																		<div className="addicon pointer">
																			<AddSharpIcon
																				onClick={() => {
																					handleOpenEducationActivity();
																					setEducationData(item);
																				}}
																			/>
																		</div>
																	</div>

																	{item.usrDataEducationActivities &&
																		item.usrDataEducationActivities
																			.filter((item) => !item.isDeleted)
																			?.map((roleItem, index) => {
																				return (
																					<div
																						className="d-flex align-items-start justify-content-between mt-2 "
																						key={index}
																					>
																						{/* <div className="ms-2"> */}
																						<div className={`ms-2 ${item?.status !== 1 ? "disabled-row" : ""}`}>

																							<div className="d-flex verified">
																								<p className="f-14 fw-bold me-2 m-0">
																									{roleItem.activity}
																								</p>
																							</div>
																						</div>
																						<div className="d-flex align-items-center updateActions">
																							<EditSharpIcon
																								className={`material-symbols-sharp pointer ms-2 me-2 locationIcon ${item?.status !== 1 ? "disabled-row" : ""}`}
																								// className="material-symbols-sharp pointer ms-2 me-2 locationIcon"
																								onClick={() => {
																									handleOpenUpdateEducationActivity();
																									setEducationActivityData(
																										roleItem
																									);
																									setEducationData(item);
																								}}
																							/>
																							<DeleteOutlineSharpIcon
																								className="material-symbols-sharp pointer delete-icon   text-red"
																								onClick={() => {
																									setShowEducationActivityDelete(
																										!showeducatonActivityDelete
																									);
																									setEducationId(
																										item.usrDataEductnId
																									);
																									setEducationActivityId(
																										roleItem.usrDataEduActvtyId
																									);
																									setEducationData(roleItem.activity);
																								}}
																							/>
																						</div>
																					</div>
																				);
																			})}
																</div>

																<div className="mt-2">
																	<div className="d-flex justify-content-between align-center border-custom">
																		<div className="title  ">
																			<h6 className="f-12 f-600 ms-2 mb-1">
																				Education Achievement
																			</h6>
																		</div>
																		<div className="addicon pointer">
																			<AddSharpIcon
																				onClick={() => {
																					handleOpenEducationAhievement();
																					setEducationData(item);
																				}}
																			/>
																		</div>
																	</div>

																	{item.usrDataEducationAchievements &&
																		item.usrDataEducationAchievements
																			.filter((item) => !item.isDeleted)
																			?.map((roleItem, index) => {
																				console.log("roleItem", roleItem);

																				return (
																					<div
																						className="d-flex align-items-start justify-content-between mt-2 "
																						key={index}
																					>
																						{/* <div className="ms-2"> */}
																						<div className={`ms-2 ${item?.status !== 1 ? "disabled-row" : ""}`}>

																							<div className="d-flex verified">
																								<p className="f-14 ms-1 fw-bold me-2 m-0">
																									{roleItem.achievement} {roleItem.achievementDate === null || roleItem.achievementDate === "" ? "" :
																										<>
																											<span className="f-500">({moment(roleItem.achivementDate).format("DD MMM YYYY")})</span>
																										</>
																									}
																								</p>

																							</div>
																						</div>
																						<div className="d-flex align-items-center updateActions">

																							<EditSharpIcon
																								className={`material-symbols-sharp pointer ms-2 me-2 locationIcon ${item?.status !== 1 ? "disabled-row" : ""}`}
																								// className="material-symbols-sharp pointer ms-2 me-2 locationIcon"
																								onClick={() => {
																									handleOpenUpdateEducationAchievement();
																									setEducationAchievementData(roleItem);
																									setEducationData(item);
																								}}
																							/>
																							<DeleteOutlineSharpIcon
																								className="material-symbols-sharp pointer delete-icon   text-red"
																								onClick={() => {
																									setShowEducationActivityAchievDelete(
																										!showeducatonActivityAchivDelete
																									);
																									setEducationId(
																										item.usrDataEductnId
																									);
																									setEducationActivityAchievId(
																										roleItem.usrDataEduAchvmntId
																									);
																									setEducationData(roleItem.achivementDate);
																									setEducationActivityAchiev(roleItem.achievement);
																								}}
																							/>
																						</div>
																					</div>
																				);
																			})}
																</div>
															</div>
														);
													})}
										</div>
									</div>
								</div>
							</div>
							{/* //  *******************************   EDUCATION CARD END ************************************************ */}

							{/* //  *******************************   EXPERIENCE CARD START ************************************************ */}
							<div className="card d-flex align-center Experience mt-2 pt-0 pb-0">
								<div className="post-job-details-form Edit-Card-details-form">
									<div className="profile-section">
										<div className=" mt-2">
											<div className="d-flex justify-content-between border-custom">
												<div className="title">
													<h6 className="f-600">Experience</h6>
												</div>
												<div className="addicon pointer">
													<AddSharpIcon onClick={handleOpenExperience} />
												</div>
											</div>
											{userExperience &&
												userExperience
													.filter((item) => !item.isDeleted)
													?.map((item, index, filteredArray) => {
														console.log('item experience', item);
														const isLastItem = index === filteredArray?.length - 1;
														return (
															<div
																className={`analytic-sub mt-2 mb-3 ${isLastItem ? "" : "border-custom1"
																	} pb - 3`}
																key={index}
															>
																<div className="d-flex align-items-start justify-content-between ">

																	<div className={`ms-2 ${item?.status !== 1 ? "disabled-row" : ""}`}>

																		<div className="d-flex verified">
																			<p className="f-14 ms-1 fw-bold me-2 m-0">
																				{item.jobTitle}
																			</p>
																		</div>
																		<div className="d-flex">
																			<p className="ms-1 me-1 f-14 fw-bold mb-0">
																				{item.companyName}
																			</p>
																			<div className="dot"></div>
																			<p className="ms-2 f-14 fw-bold mb-0">
																				{item.jobTypeName}
																			</p>
																		</div>
																		<div className="d-flex align-items-center">
																			<PlaceSharpIcon className="material-symbols-sharp locationIcon f-14" />
																			<p className="ms-1 me-1 f-12 mb-0">
																				{item.cityName}
																			</p>
																			<div className="dot"></div>
																			<p className="ms-2 f-12 mb-0">
																				({moment(item.startDate).format("DD MMM YYYY")} {item.endDate === "" || item.endDate === null
																					? " - Present"
																					: <>
																						- {moment(item.endDate).format("DD MMM YYYY")}

																					</>
																				}
																				)
																			</p>
																		</div>
																		<div className="d-flex">
																			<p className="ms-1 me-1 f-14 mb-0">{item.description}</p>

																		</div>
																	</div>
																	<div className="d-flex align-items-center updateActions">
																		<label class="switch">
																			<input
																				type="checkbox"
																				defaultChecked={item?.status === 1}
																				onClick={() => {
																					if (item?.status === 1) {
																						DisableExperience(item.usrDataExpId);
																					} else {
																						EnableExperience(item.usrDataExpId);
																					}
																				}}
																			/>
																			<span class="slider round"></span>
																		</label>
																		<EditSharpIcon
																			className={`material-symbols-sharp pointer ms-2 me-2 locationIcon ${item?.status !== 1 ? "disabled-row" : ""}`}
																			// className="material-symbols-sharp pointer ms-2 me-2 locationIcon"
																			onClick={() => {
																				handleOpenEditExperience();
																				setExperienceData(item);
																			}}
																		/>

																		<DeleteOutlineSharpIcon
																			className="material-symbols-sharp pointer delete-icon   text-red"
																			onClick={() => {
																				setShowExperienceDelete(
																					!showExperienceDelete
																				);
																				setExperienceId(item.usrDataExpId);
																			}}
																		/>
																	</div>
																	{/* )} */}
																</div>
																<div className="mt-2">
																	<div className="d-flex justify-content-between align-center border-custom">
																		<div className="title  ">
																			<h6 className="f-12 f-600 ms-2">Experience Role</h6>
																		</div>
																		<div className="addicon pointer">
																			<AddSharpIcon
																				onClick={() => {
																					handleOpenExperienceRole();
																					setExperienceData(item);
																				}}
																			/>
																		</div>
																	</div>

																	{item.usrDataExperienceRoles &&
																		item.usrDataExperienceRoles
																			.filter((item) => !item.isDeleted)
																			?.map((roleItem, index) => {
																				return (
																					<div
																						className="d-flex align-items-start justify-content-between mt-2 "
																						key={index}
																					>
																						<div className={`ms-2 ${item?.status !== 1 ? "disabled-row" : ""}`}>

																							<div className="d-flex verified">
																								<p className="f-14   fw-bold me-2 m-0">
																									{roleItem.role}
																								</p>
																							</div>
																						</div>
																						<div className="d-flex align-items-center updateActions">
																							{/* <label className="switch">
																								<input
																									type="checkbox"
																									defaultChecked={
																										roleItem?.status === 1
																									}
																									onClick={() => {
																										if (roleItem?.status === 1) {
																											DisableExperienceRole(
																												roleItem.usrDataExpRlId, // Role ID
																												roleItem.role,
																												item.usrDataExpId // Experience ID
																											);
																										} else {
																											EnableExperienceRole(
																												roleItem.usrDataExpRlId, // Role ID
																												roleItem.role,
																												item.usrDataExpId // Experience ID
																											);
																										}
																									}}
																								/>
																								<span className="slider round"></span>
																							</label> */}
																							<EditSharpIcon
																								className={`material-symbols-sharp pointer ms-2 me-2 locationIcon ${roleItem?.status !== 1 ? "disabled-row" : ""}`}
																								// className="material-symbols-sharp pointer ms-2 me-2 locationIcon"
																								onClick={() => {
																									handleOpenEditExperienceRole();
																									setExperienceRoleData(roleItem);
																									setExperienceData(item);
																								}}
																							/>
																							<DeleteOutlineSharpIcon
																								className="material-symbols-sharp pointer delete-icon   text-red"
																								onClick={() => {
																									setShowExperienceRoleDelete(
																										!showExperienceRoleDelete
																									);
																									setExperienceId(
																										item.usrDataExpId
																									);
																									setExperienceRoleId(
																										roleItem.usrDataExpRlId
																									);
																									setExperienceRole(roleItem.role);
																								}}
																							/>
																						</div>
																					</div>
																				);
																			})}
																</div>

																<div className="mt-2">
																	<div className="d-flex justify-content-between border-custom">
																		<div className="title ">
																			<h6 className=" f-12 f-600 ms-2">
																				Experience Achievement
																			</h6>
																		</div>
																		<div className="addicon pointer">
																			<AddSharpIcon
																				onClick={() => {
																					handleOpenExperienceAchivement();
																					setExperienceData(item);
																				}}
																			/>
																		</div>
																	</div>

																	{item.usrDataExperienceAchievements &&
																		item.usrDataExperienceAchievements
																			.filter((item) => !item.isDeleted)
																			?.map((roleItem, index) => {
																				return (
																					<div
																						className="d-flex align-items-start justify-content-between mt-2"
																						key={index}
																					>
																						<div className={`ms-2 ${item?.status !== 1 ? "disabled-row" : ""}`}>

																							<div className="d-flex verified">
																								<p className="f-14   fw-bold me-2 m-0">
																									{roleItem.achievement}
																									{roleItem.startDate === null || roleItem.startDate === "" ? "" : (
																										<>
																											<span className="f-14 ms-1  f-500 me-2 m-0">
																												({moment(roleItem.achivementDate).format("DD MMM YYYY")})
																											</span>
																										</>
																									)}
																								</p>
																							</div>
																						</div>
																						<div className="d-flex align-items-center updateActions">
																							{/* <label className="switch">
																								<input
																									type="checkbox"
																									defaultChecked={
																										roleItem?.status === 1
																									}
																									onClick={() => {
																										if (roleItem?.status === 1) {
																											DisableExperienceAchivement(
																												roleItem.usrDataExpAchvmntId, // Role ID
																												roleItem.achievement,
																												item.usrDataExpId // Experience ID
																											);
																										} else {
																											EnableExperienceAchivement(
																												roleItem.usrDataExpAchvmntId, // Role ID
																												roleItem.achievement,
																												item.usrDataExpId // Experience ID
																											);
																										}
																									}}
																								/>
																								<span className="slider round"></span>
																							</label> */}
																							<EditSharpIcon
																								className={`material-symbols-sharp pointer ms-2 me-2 locationIcon ${roleItem?.status !== 1 ? "disabled-row" : ""}`}
																								// className="material-symbols-sharp pointer ms-2 me-2 locationIcon"
																								onClick={() => {
																									handleOpenEditExperienceAchivement();
																									setExperienceAchivementData(
																										roleItem
																									);
																									setExperienceData(item);
																								}}
																							/>
																							<DeleteOutlineSharpIcon
																								className="material-symbols-sharp pointer delete-icon  text-red"
																								onClick={() => {
																									setShowExperienceAchievementDelete(
																										!showExperienceAchievementDelete
																									);
																									setExperienceId(
																										item.usrDataExpId
																									);
																									setExperienceAchivementId(
																										roleItem.usrDataExpAchvmntId
																									);
																									setExperienceAchivement(
																										roleItem.achievement
																									);
																								}}
																							/>
																						</div>
																					</div>
																				);
																			})}
																</div>
															</div>
														);
													})}
										</div>
									</div>
								</div>
							</div>
							{/* //  *******************************    EXPERIENCE CARD END ************************************************ */}

							{/* //  *******************************    CERTIFICATION CARD START ************************************************ */}
							<div className="card d-flex align-center Certification mt-2 pt-0 pb-0">
								<div className="post-job-details-form Edit-Card-details-form">
									<div className="profile-section">
										<div className="info-row mt-2">
											<div className="d-flex justify-content-between border-custom">
												<div className="title">
													<h6 className="f-600">Certification</h6>
												</div>
												<div className="addicon pointer">
													<AddSharpIcon onClick={handleOpenCVCertification} />
												</div>
											</div>
										</div>
										{userCertification &&
											userCertification
												.filter((item) => !item.isDeleted)
												?.map((item, index, filteredArray) => {
													console.log('item certificate==>', item);
													const isLastItem =
														index === filteredArray?.length - 1;

													return (
														<div
															// className={`analytic-sub mt-2 mb-1 ${isLastItem ? "border-custom2" : "border-custom"} pb-2`}
															className={`analytic-sub mt-2 mb-1 ${!isLastItem ? "border-custom" : "border-custom2"} pb-2`}
															key={index}
														>
															<div className="d-flex align-items-start justify-content-between">
																<div className={`ms-2 ${item?.status !== 1 ? "disabled-row" : ""}`}>

																	<div className="d-flex verified">
																		<p className="f-14 ms-1 fw-bold me-2 m-0">
																			{item.name}
																		</p>
																	</div>
																	<div className="d-flex">
																		<p className="ms-1 me-1 f-14 f-600  mb-0">
																			{item.orgName}
																		</p>
																		<div className="dot"></div>
																		<p className="f-14   mb-0">
																			{item.recognition}
																		</p>
																		<div className="dot"></div>
																		<p className="ms-2 me-1 f-14   mb-0">
																			{item.credentialId}
																		</p>
																	</div>
																	<div className="d-flex align-items-center location-issueexp-date">
																		{item.cityName === null ? '' : (
																			<>
																				<div style={{ alignItems: "center" }} className="d-flex locationicon-svg">
																					<PlaceSharpIcon className="material-symbols-sharp locationIcon f-14" />
																					<p className="ms-1 mb-0 me-1 f-12">
																						{item.cityName}
																					</p>
																				</div>
																			</>
																		)}
																		<div className="dot"></div>
																		<p className=" f-12 mb-0  issue-exp-date-mob">
																			({moment(item.issueDate).format("DD MMM YYYY")} )
																			{item.expirationDate === "" || item.expirationDate === null
																				? " - Present" :
																				<>
																					- ({moment(item.expirationDate).format("DD MMM YYYY")})
																				</>
																			}

																		</p>
																	</div>
																</div>
																<div className="d-flex align-items-center updateActions">
																	<label class="switch">
																		<input
																			type="checkbox"
																			defaultChecked={item?.status === 1}
																			onClick={() => {
																				if (item?.status === 1) {
																					DisableCertificate(
																						item.usrDataCertfctnId
																					);
																				} else {
																					EnableCertificate(item.usrDataCertfctnId);
																				}
																			}}
																		/>
																		<span class="slider round"></span>
																	</label>

																	<EditSharpIcon
																		className={`material-symbols-sharp pointer ms-2 me-2 locationIcon ${item?.status !== 1 ? "disabled-row" : ""}`}
																		// className="material-symbols-sharp pointer me-2 ms-2 locationIcon"
																		onClick={() => {
																			handleOpenEditCertificate();
																			// setShowUpdateCVCertification(
																			//   !showCVUpdateCertification
																			// );
																			setCertificateData(item);
																		}}
																	/>
																	<DeleteOutlineSharpIcon
																		className="material-symbols-sharp pointer delete-icon text-red"
																		onClick={() => {
																			setShowCertificationDelete(
																				!showCertificationDelete
																			);
																			setCertId(item.usrDataCertfctnId);
																		}}
																	/>
																</div>
															</div>
														</div>
													);
												})}
									</div>
								</div>
							</div>
							{/* //  *******************************    CERTIFICATION CARD END ************************************************ */}

							{/* //  *******************************    AWARDS CARD START ************************************************ */}
							<div className="card d-flex align-center Awards mt-2 pt-0 pb-0  ">
								<div className="post-job-details-form Edit-Card-details-form">
									<div className="profile-section">
										<div className=" mt-2">
											<div className="d-flex justify-content-between border-custom">
												<div className="title">
													<h6 className="f-600">Awards</h6>
												</div>
												<div
													className="addicon pointer"
													onClick={() => {
														handleOpenAward();
													}}
												>
													<AddSharpIcon />
												</div>
											</div>

											{userAwards &&
												userAwards
													.filter((item) => !item.isDeleted)
													?.map((item, index, filteredArray) => {
														console.log('Award item', item);
														const isLastItem = index === filteredArray?.length - 1;

														return (
															<div
																className={`analytic-sub mt-2 mb-1 ${isLastItem ? "" : "border-custom"
																	} pb - 2`}
																key={index}
															>
																<div className="d-flex align-items-start justify-content-between">

																	<div className={`ms-2 ${item?.status !== 1 ? "disabled-row" : ""}`}>
																		<div className="d-flex verified">
																			<p className="f-14 ms-1 f-600 me-2 m-0">
																				{item.name}
																			</p>
																		</div>
																		<div className="d-flex">
																			<p className="ms-1 me-1 f-14 f-600 mb-0">
																				{item.orgName}
																			</p>
																			<div className="dot"></div>
																			<p className="ms-1 me-1 f-14   mb-0">
																				{item.recognition}
																			</p>
																		</div>
																		<div className="d-flex align-items-center">
																			{item.cityName === null ? '' : (
																				<>
																					<PlaceSharpIcon className="material-symbols-sharp locationIcon f-14" />
																					<p className="ms-1 mb-0   f-12">
																						{item.cityName}
																					</p>
																				</>

																			)}<p className="ms-2 f-12 mb-0 ">
																				{item.issueDate === null || item.issueDate === "" ? "" : (
																					<>
																						({moment(item.issueDate).format("DD MMM YYYY")})
																					</>
																				)}
																			</p>
																		</div>
																		<div className="d-flex">
																			<p className="ms-1 mb-0 me-1 f-12">
																				{item.description}
																			</p>
																		</div>
																	</div>
																	<div className="d-flex align-items-center updateActions">
																		<label class="switch">
																			<input
																				type="checkbox"
																				defaultChecked={item?.status === 1}
																				onClick={() => {
																					if (item?.status === 1) {
																						DisableAward(item.usrDataAwrdId);
																					} else {
																						EnableAward(item.usrDataAwrdId);
																					}
																				}}
																			/>
																			<span class="slider round"></span>
																		</label>

																		<EditSharpIcon
																			className={`material-symbols-sharp pointer ms-2 me-2 locationIcon ${item?.status !== 1 ? "disabled-row" : ""}`}
																			// className="material-symbols-sharp pointer me-2 ms-2 locationIcon"
																			onClick={() => {
																				handleOpenUpdateCVAward();
																				setAwardData(item);
																			}}
																		/>
																		<DeleteOutlineSharpIcon
																			className="material-symbols-sharp pointer delete-icon text-red"
																			onClick={() => {
																				setShowAwardDelete(!showAwardDelete);
																				setAwardId(item.usrDataAwrdId);
																			}}
																		/>
																	</div>
																</div>
															</div>
														);
													})}
										</div>
									</div>
								</div>
							</div>
							{/* //  *******************************    AWARDS CARD END ************************************************ */}

							{/* //  *******************************    SKILLS CARD START ************************************************ */}
							<div className="card d-flex align-center  Skills mt-2 pt-0 pb-0">
								<div className="post-job-details-form Edit-Card-details-form">
									<div className="profile-section">
										<div className="info-row mt-2">
											<div className="d-flex justify-content-between border-custom">
												<div className="title">
													<h6 className="f-600">Skills</h6>
												</div>
												<div
													className="addicon pointer"
													onClick={handleOpenAddSkill}
												>
													<AddSharpIcon
														onClick={() => {
															handleOpenAddSkill();
															// setAddSkillsData(item);
														}}
													/>
												</div>
											</div>
										</div>
										{userSkill &&
											userSkill
												.filter((item) => !item.isDeleted)
												?.map((item, index, filteredArray) => {
													console.log("Skill item===>", item)
													const isLastItem = index === filteredArray?.length - 1;
													return (
														<div
															className={`analytic-sub mt-2 mb-1 ${isLastItem ? "" : "border-custom"
																} pb - 2`}
															key={index}
														>
															<div className="d-flex align-items-start justify-content-between">
																<div className={`ms-2  `}>
																	<div className="d-flex verified">
																		<p className="f-14 ms-1 me-2 m-0  fw-bold">
																			{item.fiName}
																		</p>
																	</div>
																	<div className="d-flex verified">
																		<p className="f-14 ms-1 me-2 m-0">
																			{item.skillName}
																		</p>
																	</div>
																</div>
																<div className="d-flex align-items-center updateActions">
																	<EditSharpIcon
																		className={`material-symbols-sharp pointer ms-2 me-2 locationIcon  `}
																		// className="material-symbols-sharp pointer me-2 ms-2 locationIcon"
																		onClick={() => {
																			// handleOpenSkillsUpdate();
																			setShowSkillsUpdate(!showSkillsUpdate);
																			setSkillsData(item);
																		}}
																	/>
																	<DeleteOutlineSharpIcon
																		className="material-symbols-sharp pointer delete-icon  text-red"
																		onClick={() => {
																			setShowSkillDelete(!showskillDelete);
																			setSkillId(item.usrDataSkllId);
																		}}
																	/>
																</div>
															</div>
														</div>
													);
												})}
									</div>
								</div>
							</div>
							{/* //  *******************************    SKILLS CARD END ************************************************ */}

							{/* //  *******************************    ATTACHEMENT CARD START ************************************************ */}
							<div className="d-flex align-center delete-card Attachment mt-1 pt-0 pb-0 mb-1"></div>
							{/* //  *******************************    ATTTACHEMENT CARD END ************************************************ */}

							{/* //  *******************************    PROJECT CARD START ************************************************ */}
							<div className="card d-flex align-center Add-project pt-0 pb-0 mb-5">
								<div className="post-job-details-form Edit-Card-details-form">
									<div className="profile-section">
										<div className="mt-2">
											<div className="d-flex justify-content-between border-custom">
												<div className="title">
													<h6 className="f-600">Project</h6>
												</div>
												<div
													className="addicon pointer"
													onClick={handleOpenAddProject}
												>
													<AddSharpIcon />
												</div>
											</div>
										</div>

										{projectData &&
											projectData
												.filter((item) => !item.isDeleted)
												?.map((item, index, filteredArray) => {
													console.log("Project Data==>", item)
													const isLastItem = index === filteredArray?.length - 1;
													console.log('projectData', projectData);
													return (
														<div
															className={`analytic-sub mt-2 mb-1 ${isLastItem ? "" : "border-custom"
																} pb - 2`}
															key={index}
														>
															<div className="d-flex align-items-start justify-content-between pb-2 ">
																{/* <div className="ms-2"> */}
																<div className={` ${item?.status !== 1 ? "disabled-row" : ""}`}>

																	<div className="d-flex verified">
																		<p className="f-14 ms-1 fw-bold me-2 m-0">
																			{item.name} <span className="f-12 f-400">
																				{item.startMonth === null ? "" :
																					<>
																						({moment(item.startMonth).format("MMM")} {moment(item.startYear).format("YYYY")})
																					</>
																				}
																				{item.endYear === null || item.endYear === "Invalid date" ? "- Currently working on " : (
																					<>
																						- ({moment(item.endMonth).format("MMM")} {moment(item.endYear).format("YYYY")})
																					</>
																				)}
																			</span>
																		</p>
																	</div>

																	<div className="d-flex">
																		<p className="ms-1 me-1 f-14 mb-0">
																			{item.associatedWith} {item.projectUrl === null ? "" : (
																				<>
																					{item.projectUrl} </>
																			)}
																		</p>
																	</div>
																	<div className="d-flex">
																		<p className="ms-1 me-1 f-14 mb-0">
																			{item.description}
																		</p>
																	</div>

																</div>
																<div className="d-flex align-items-center updateActions">
																	<label class="switch">
																		<input
																			type="checkbox"
																			defaultChecked={item?.status === 1}
																			onClick={() => {
																				if (item?.status === 1) {
																					DisableProject(item.usrDataPrjctId);
																				} else {
																					EnableProject(item.usrDataPrjctId);
																				}
																			}}
																		/>
																		<span class="slider round"></span>
																	</label>
																	<EditSharpIcon
																		className={`material-symbols-sharp pointer ms-2 me-2 locationIcon ${item?.status !== 1 ? "disabled-row" : ""}`}
																		onClick={() => {
																			handleOpenEditProject();
																			//   setProjectAllData(item);
																			setProjectAllData(item);
																		}}
																	/>

																	<DeleteOutlineSharpIcon
																		className="material-symbols-sharp pointer delete-icon text-red"
																		onClick={() => {
																			setShowProjectDelete(!showProjectDelete);
																			setProjectId(item.usrDataPrjctId);
																		}}
																	/>
																</div>
																{/* )} */}
															</div>
														</div>
													);
												})}
									</div>
								</div>
							</div>
							{/* //  *******************************    PROJECT CARD END ************************************************ */}
						</div>
					</div>
				</>
			)}
			{/* //  *******************************    UPDATE RESUME COMPONENTS ************************************************ */}
			<UpdateResume
				show={showEditViewResume}
				handleClose={handleCloseEditViewResume}
				userDataInfo={userDataInfo}
				getUserCv={getUserCv}
			/>
			{/* //  *******************************     UPDATE RESUME COMPONENTS ************************************************ */}
			{/* //  *******************************    ActiveAs RESUME COMPONENTS ************************************************ */}
			<UpdateResume
				showActiveAs={showEditActiveAs}
				handleCloseActiveAs={handleCloseActiveAs}
				userDataInfo={userDataInfo}
				getUserCv={getUserCv}
			/>
			{/* //  *******************************     Active as RESUME COMPONENTS ************************************************ */}

			{/* //  *******************************    EDUCATION COMPONENTS ************************************************ */}
			<AddEducation
				userDataId={userDataId}
				userDataInfo={userDataInfo}
				show={showEducation}
				handleClose={handleCloseEducation}
				getUserCv={getUserCv}
			/>
			<EditEducation
				userEducation={educationData}
				userDataInfo={userDataInfo}
				userDataId={userDataId}
				show={showEducationUpdate}
				handleClose={handleCloseUpdateEducation}
				getUserCv={getUserCv}
			/>

			<Modal
				show={showEducationDelete}
				onHide={handleRemoveEducationClose}
				centered
			>
				<Modal.Header>
					<Modal.Title>Confirm delete</Modal.Title>
					<CloseSharpIcon
						className="pointer"
						onClick={handleRemoveEducationClose}
					/>
				</Modal.Header>
				<Modal.Body className="settings">
					<div className=" mb-3">
						<p>Are you sure you want to delete your Education?</p>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<button onClick={DeleteEducation} className="btn btn-danger me-2">
						Confirm delete
					</button>
					<button
						onClick={handleRemoveEducationClose}
						className="btn btn-secondary"
					>
						Cancel
					</button>
				</Modal.Footer>
			</Modal>

			{/* //  *******************************    EDUCATION COMPONENTS ************************************************ */}

			{/* //  *******************************    EDUCATION ACTIVITY ************************************************ */}

			<AddEducationActivity
				showEducationActivity={showEducationActivity}
				handleCloseEducationActivity={handleCloseEducationActivity}
				educationData={educationData}
				userDataId={userDataId}
				getUserCv={getUserCv}
			/>
			<UpdateEducationActivity
				showUpdateEducationActivity={showUpdateEducationActivity}
				handleCloseUpdateEducationActivity={handleCloseUpdateEducationActivity}
				userDataId={userDataId}
				getUserCv={getUserCv}
				educationData={educationData}
				educationActivityData={educationActivityData}
				ActivityId={CandidateId}
			/>

			<Modal
				show={showeducatonActivityDelete}
				onHide={handleEducationActivityClose}
				centered
			>
				<Modal.Header>
					<Modal.Title>Confirm delete</Modal.Title>
					<CloseSharpIcon
						className="pointer"
						onClick={handleEducationActivityClose}
					/>
				</Modal.Header>
				<Modal.Body className="settings">
					<div className=" mb-3">
						<p>Are you sure you want to delete your Education Activity ?</p>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<button
						onClick={DeleteEducationActivity}
						className="btn btn-danger me-2"
					>
						Confirm delete
					</button>
					<button
						onClick={handleEducationActivityClose}
						className="btn btn-secondary"
					>
						Cancel
					</button>
				</Modal.Footer>
			</Modal>

			{/* //  *******************************    EDUCATION ACTIVITY ************************************************ */}

			{/* //  *******************************    EDUCATION ACHIEVEMENT ************************************************ */}
			<AddEducationAchievement
				showEducationAchievement={showEducationAchievement}
				handleCloseEducationAhievement={handleCloseEducationAhievement}
				educationData={educationData}
				userDataId={userDataId}
				getUserCv={getUserCv}
			/>

			<UpdateEducationAchievement
				showUpdateEducationAchievement={showUpdateEducationAchievement}
				handleCloseUpdateEducationAhievement={handleCloseUpdateEducationAhievement}
				educationData={educationData}
				educationAchievementData={educationAchievementData}
				userDataId={userDataId}
				getUserCv={getUserCv}
			/>

			<Modal
				show={showeducatonActivityAchivDelete}
				onHide={handleEducationActivityAchiveClose}
				centered
			>
				<Modal.Header>
					<Modal.Title>Confirm delete</Modal.Title>
					<CloseSharpIcon
						className="pointer"
						onClick={handleEducationActivityAchiveClose}
					/>
				</Modal.Header>
				<Modal.Body className="settings">
					<div className=" mb-3">
						<p>Are you sure you want to delete your Education Activity Achievement ?</p>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<button onClick={DeleteEducationActivityAchievement} className="btn btn-danger me-2">
						Confirm delete
					</button>
					<button
						onClick={handleEducationActivityAchiveClose}
						className="btn btn-secondary"
					>
						Cancel
					</button>
				</Modal.Footer>
			</Modal>
			{/* //  *******************************    EDUCATION ACHIEVEMENT ************************************************ */}

			{/* //  *******************************    EXPERIENCE COMPONENTS ************************************************ */}
			<AddExperience
				userDataId={userDataId}
				userDataInfo={userDataInfo}
				show={showExperience}
				handleClose={handleCloseExperience}
				getUserCv={getUserCv}
			/>
			<EditExperience
				userDataId={userDataId}
				userDataInfo={userDataInfo}
				experienceData={experienceData}
				show={showEditExperience}
				getUserCv={getUserCv}
				handleClose={handleCloseEditExperience}
			/>
			<Modal
				show={showExperienceDelete}
				onHide={handleRemoveExperienceClose}
				centered
			>
				<Modal.Header>
					<Modal.Title>Confirm delete</Modal.Title>
					<CloseSharpIcon
						className="pointer"
						onClick={handleRemoveExperienceClose}
					/>
				</Modal.Header>
				<Modal.Body className="settings">
					<div className=" mb-3">
						<p>Are you sure you want to delete your Experience?</p>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<button onClick={DeleteExperience} className="btn btn-danger me-2">
						Confirm delete
					</button>
					<button
						onClick={handleRemoveExperienceClose}
						className="btn btn-secondary"
					>
						Cancel
					</button>
				</Modal.Footer>
			</Modal>
			{/* //  *******************************    EXPERIENCE COMPONENTS ************************************************ */}

			{/* //  *******************************    EXPERIENCE ROLE COMPONENTS ************************************************ */}

			<AddExperienceRole
				showExperienceRole={showExperienceRole}
				handleCloseExperienceRole={handleCloseExperienceRole}
				experienceData={experienceData}
				userDataId={userDataId}
				getUserCv={getUserCv}
			/>

			<EditExperienceRole
				handleCloseEditExperienceRole={handleCloseEditExperienceRole}
				showEditExperienceRole={showEditExperienceRole}
				experienceRoleData={experienceRoleData}
				experienceData={experienceData}
				userDataId={userDataId}
				getUserCv={getUserCv}
			/>
			<Modal
				show={showExperienceRoleDelete}
				onHide={handleRemoveExperienceRoleClose}
				centered
			>
				<Modal.Header>
					<Modal.Title>Confirm delete</Modal.Title>
					<CloseSharpIcon
						className="pointer"
						onClick={handleRemoveExperienceRoleClose}
					/>
				</Modal.Header>
				<Modal.Body className="settings">
					<div className=" mb-3">
						<p>Are you sure you want to delete your Experience Role?</p>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<button
						onClick={DeleteExperienceRole}
						className="btn btn-danger me-2"
					>
						Confirm delete
					</button>
					<button
						onClick={handleRemoveExperienceRoleClose}
						className="btn btn-secondary"
					>
						Cancel
					</button>
				</Modal.Footer>
			</Modal>
			{/* //  *******************************    EXPERIENCE ROLE COMPONENTS ************************************************ */}

			{/* //  *******************************    EXPERIENCE ACHIEVEMENT COMPONENTS ************************************************ */}
			<AddExperienceAchivement
				showExperienceAchivement={showExperienceAchivement}
				handleCloseExperienceAchivement={handleCloseExperienceAchivement}
				experienceData={experienceData}
				userDataId={userDataId}
				getUserCv={getUserCv}
			/>

			<EditExperienceAchivement
				handleCloseEditExperienceAchivement={
					handleCloseEditExperienceAchivement
				}
				showEditExperienceAchivement={showEditExperienceAchivement}
				experienceAchivementData={experienceAchivementData}
				experienceData={experienceData}
				userDataId={userDataId}
				getUserCv={getUserCv}
			/>

			<Modal
				show={showExperienceAchievementDelete}
				onHide={handleExperienceAchievementClose}
				centered
			>
				<Modal.Header>
					<Modal.Title>Confirm delete</Modal.Title>
					<CloseSharpIcon
						className="pointer"
						onClick={handleExperienceAchievementClose}
					/>
				</Modal.Header>
				<Modal.Body className="settings">
					<div className=" mb-3">
						<p>Are you sure you want to delete your Experience Achievement?</p>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<button
						onClick={DeleteExperienceAchivement}
						className="btn btn-danger me-2"
					>
						Confirm delete
					</button>
					<button
						onClick={handleExperienceAchievementClose}
						className="btn btn-secondary"
					>
						Cancel
					</button>
				</Modal.Footer>
			</Modal>
			{/* //  *******************************    EXPERIENCE ACHIEVEMENT COMPONENTS ************************************************ */}

			{/* //  *******************************     CERTIFICATION COMPONENTS ************************************************ */}
			<AddCertificate
				showCertificate={showCVCertification}
				handleCloseCertification={handleCloseCVCertification}
				userDataId={userDataId}
				getUserCv={getUserCv}
			/>
			<UpdateCertificate
				showEditCertificate={showEditCertificate}
				handleCloseEditCertificate={handleCloseEditCertificate}
				certificateData={certificateData}
				userDataId={userDataId}
				getUserCv={getUserCv}
			/>
			<Modal
				show={showCertificationDelete}
				onHide={handleRemoveCertificationClose}
				centered
			>
				<Modal.Header>
					<Modal.Title>Confirm delete</Modal.Title>
					<CloseSharpIcon
						className="pointer"
						onClick={handleRemoveCertificationClose}
					/>
				</Modal.Header>
				<Modal.Body className="settings">
					<div className=" mb-3">
						<p>Are you sure you want to delete your Certificate?</p>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<button onClick={DeleteCertification} className="btn btn-danger me-2">
						Confirm delete
					</button>
					<button
						onClick={handleRemoveCertificationClose}
						className="btn btn-secondary"
					>
						Cancel
					</button>
				</Modal.Footer>
			</Modal>
			{/* //  *******************************     CERTIFICATION COMPONENTS ************************************************ */}

			{/* //  *******************************     AWARDS COMPONENTS ************************************************ */}
			<AddAward
				showAward={showAward}
				userDataId={userDataId}
				getUserCv={getUserCv}
				handleCloseAward={handleCloseAward}
			/>
			<UpdateAward
				showUpdateAward={showCVUpdateAward}
				userDataId={userDataId}
				awardData={awardData}
				getUserCv={getUserCv}
				handleCloseUpdateAward={handleCloseUpdateCVAward}
			/>
			<Modal show={showAwardDelete} onHide={handleRemoveAwardClose} centered>
				<Modal.Header>
					<Modal.Title>Confirm delete</Modal.Title>
					<CloseSharpIcon
						className="pointer"
						onClick={handleRemoveAwardClose}
					/>
				</Modal.Header>
				<Modal.Body className="settings">
					<div className=" mb-3">
						<p>Are you sure you want to delete your Award?</p>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<button onClick={DeleteAward} className="btn btn-danger me-2">
						Confirm delete
					</button>
					<button
						onClick={handleRemoveAwardClose}
						className="btn btn-secondary"
					>
						Cancel
					</button>
				</Modal.Footer>
			</Modal>
			{/* //  *******************************     AWARDS COMPONENTS ************************************************ */}

			{/* //  *******************************     SKILLS COMPONENTS ************************************************ */}
			<AddSkills
				show={showAddSkill}
				handleClose={handleCloseAddSkill}
				userDataId={userDataId}
				getUserCv={getUserCv}
			/>
			<EditSkills
				show={showSkillsUpdate}
				handleClose={handleCloseSkillUpdate}
				skillsData={skillsData}
				userDataId={userDataId}
				getUserCv={getUserCv}
			/>
			<Modal show={showskillDelete} onHide={handleRemoveskillClose} centered>
				<Modal.Header>
					<Modal.Title>Confirm delete</Modal.Title>
					<CloseSharpIcon
						className="pointer"
						onClick={handleRemoveskillClose}
					/>
				</Modal.Header>
				<Modal.Body className="settings">
					<div className=" mb-3">
						<p>Are you sure you want to delete your Skill?</p>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<button onClick={DeleteSkill} className="btn btn-danger me-2">
						Confirm delete
					</button>
					<button
						onClick={handleRemoveskillClose}
						className="btn btn-secondary"
					>
						Cancel
					</button>
				</Modal.Footer>
			</Modal>
			{/* //  *******************************     SKILLS COMPONENTS ************************************************ */}

			{/* //  *******************************     PROJECT COMPONENTS ************************************************ */}
			<AddProject
				userDataId={userDataId}
				showAddProject={showAddProject}
				handleCloseAddProject={handleCloseAddProject}
				getUserCv={getUserCv}
			/>
			<EditProject
				projectAllData={projectAllData}
				showEditProject={showEditProject}
				handleCloseEditProject={handleCloseEditProject}
				userDataId={userDataId}
				getUserCv={getUserCv}
			/>

			<Modal show={showProjectDelete} onHide={handleProjectClose} centered>
				<Modal.Header>
					<Modal.Title>Confirm delete</Modal.Title>
					<CloseSharpIcon className="pointer" onClick={handleProjectClose} />
				</Modal.Header>
				<Modal.Body className="settings">
					<div className=" mb-3">
						<p>Are you sure you want to delete your Project?</p>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<button onClick={DeleteProject} className="btn btn-danger me-2">
						Confirm delete
					</button>
					<button onClick={handleProjectClose} className="btn btn-secondary">
						Cancel
					</button>
				</Modal.Footer>
			</Modal>
			{/* //  *******************************     PROJECT COMPONENTS ************************************************ */}


			{/* //  *******************************     Language COMPONENTS ************************************************ */}
			<UpdateLangugae
				languageModal={languageModal}
				setLanguageModal={setLanguageModal}
				userDataId={userDataId}
				getUserCv={getUserCv}
				userDataInfo={userDataInfo}
			/>
			{/* //  *******************************     Language COMPONENTS ************************************************ */}

			<CareerGap
				showCareer={showCareer}
				handleCloseCareer={handleCloseCareer}
			/>
		</>
	);
};

export default ResumeDetails;
